import React from 'react';
import {
    createRoot, Root
} from 'react-dom/client';

import { AppMainEntry } from './app-main-entry';

const createEntryApp = (element: string) => {
    if (!element) {
        const message = 'Element is undefined in createEntryApp()';

        console.error(message, element);
        throw new Error(message);
    }

    const container = document.getElementById(element) as HTMLElement;

    if (!container) {
        throw new Error(`Container element "${element}" not found.`);
    }

    const root: Root = createRoot(container);

    root.render(<AppMainEntry />);
};

// Assign `createEntryApp` to the global namespace for compatibility
// @ts-ignore
window.EntryApp = createEntryApp;

// Export `createEntryApp` as the default export
export default createEntryApp;
